import buildUrl from 'build-url';

export interface Trackers {
    iosAdjustTracker: string;
    androidAdjustTracker: string;
}

const URL = 'https://zwyf.adj.st';

// For clientside use only. E.g.: with click handlers or useEffect.
export const smartAppUrl = (host: string, trackers: Trackers) => {
    const agent = navigator.userAgent || navigator.vendor;
    const { iosAdjustTracker, androidAdjustTracker } = trackers;
    let tracker = '';
    if (/Android/i.test(agent)) {
        tracker = androidAdjustTracker;
    } else if (/iPhone|iPad/i.test(agent)) {
        tracker = iosAdjustTracker;
    }

    const deepLinkURL = window.location.href;
    const fallbackURL = `${host}/m/app/`;
    return buildUrl(URL, {
        queryParams: {
            adjust_t: tracker,
            adjust_deeplink: deepLinkURL,
            adjust_fallback: fallbackURL,
        },
    });
};
